// Sharp satellite style using ESRI World Imagery (much higher resolution than Mapbox satellite).
// Use as `style: SATELLITE_STYLE` in new mapboxgl.Map().
export const SATELLITE_STYLE = {
  version: 8,
  glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}",
  sources: {
    "google-imagery": {
      type: "raster",
      tiles: [
        "https://mt0.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
        "https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
        "https://mt2.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
        "https://mt3.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
      ],
      tileSize: 256,
      maxzoom: 21,
      attribution: "© Google",
    },
  },
  layers: [
    {
      id: "google-satellite",
      type: "raster",
      source: "google-imagery",
      minzoom: 0,
      maxzoom: 22,
    },
  ],
};

// Hillshade + 3D terrain toggle for Mapbox GL maps.
// Call addTerrainLayer(map) inside map.on("load") (or equivalent).

const DEM_SRC = "mapbox-dem";

export function addTerrainLayer(map) {
  if (!map) return;

  if (!map.getSource(DEM_SRC)) {
    map.addSource(DEM_SRC, {
      type: "raster-dem",
      url: "mapbox://mapbox.mapbox-terrain-dem-v1",
      tileSize: 512,
      maxzoom: 14,
    });
  }

  if (!map.getLayer("terrain-hillshade")) {
    const firstSymbol = map.getStyle().layers.find(l => l.type === "symbol")?.id;
    map.addLayer(
      {
        id: "terrain-hillshade",
        source: DEM_SRC,
        type: "hillshade",
        paint: {
          "hillshade-shadow-color": "#1a1008",
          "hillshade-highlight-color": "#ffffff",
          "hillshade-illumination-direction": 335,
          "hillshade-exaggeration": 0.22,
        },
      },
      firstSymbol,
    );
  }

}
